export default "__VITE_ASSET__CVjOzKxo__"